"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalInventoryUpdatedContract = exports.ExternalInventoryEventDataContract = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const events_1 = require("@getgreenline/events");
class ExternalInventoryEventDataContract {
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ExternalInventoryEventDataContract.prototype, "productId", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], ExternalInventoryEventDataContract.prototype, "oldQuantity", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], ExternalInventoryEventDataContract.prototype, "quantity", void 0);
exports.ExternalInventoryEventDataContract = ExternalInventoryEventDataContract;
class ExternalInventoryUpdatedContract extends events_1.ExternalEventContract {
    constructor(params) {
        super(params);
        this.inventory = events_1.GreenlineEvent.create(ExternalInventoryEventDataContract, params.inventory);
    }
}
exports.ExternalInventoryUpdatedContract = ExternalInventoryUpdatedContract;
//# sourceMappingURL=inventory.js.map